import {BasketItemModel} from '@features/basket/interfaces';

export const getBasketChecked = (items: BasketItemModel[], itemsOut: BasketItemModel[]) => {
    const allChecked = items.length > 0 && items.every((item) => item.checked);
    const allCheckedItemsOut = itemsOut.length > 0 && itemsOut.every((item) => item.checked);

    return {allChecked, allCheckedItemsOut};
}